var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.meter)?_c('div',{staticClass:"alw-meter",attrs:{"title":_vm.title}},[_c('div',{staticClass:"alw-meter-bar"},[_c('div',{staticClass:"alw-meter-fill",class:_vm.meter.level,style:({ width: _vm.meter.pct + '%' })})]),_c('span',{staticClass:"alw-meter-label"},[_vm._v("Allowance "+_vm._s(_vm.meter.pct)+"%")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }